import { VAlert } from '@vrzl/ui';
import type { ReactNode } from 'react';

import { useAuth } from './authProvider';

const NO_PERSPECTIVE_MESSAGE =
  'Je bent succesvol ingelogd maar bent nog niet toegevoegd aan een ' +
  'bepaald perspectief, neem contact op met de administrator van dit systeem';

/**
 * Renders the full-screen "no perspective" guard for authenticated users who
 * either don't exist in the DB or have no linked perspective. Place inside
 * `<ProtectedRoute>` so it only runs after authentication has succeeded.
 */
export function PerspectiveGuard({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (user && user.activePerspective === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6">
        <div className="w-full max-w-lg">
          <VAlert variant="warning" title="Geen toegang">
            {NO_PERSPECTIVE_MESSAGE}
          </VAlert>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
